import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SidebarAdmin from './sidebaradmin';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Link, useNavigate
} from "react-router-dom";
import { getLocationList, addUser, updateUser } from '../../actions/admin.actions';
import { updateNullOfObjectValues } from '../../helpers/helper';
import secureLocalStorage from 'react-secure-storage';
import { useSelector } from 'react-redux';


const AddEditUser = ({handleTabChange}) => {
  //define form fields
  const formFields = {
    id: '',
    name: '',
    last_name: '',
    empid: '',
    email: '',
    type: '',
    location: [],
  };
  //const [locations, setLocations] = useState([]);
  const {locations} = useSelector(state => state.userdata);
  const [formValues, setFormValues] = useState(formFields);
  const [formErrors, setFormErrors] = useState(updateNullOfObjectValues(formFields));
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (document.body.classList.contains('adminbody_bg')) {
      document.body.classList.remove('body');
    }
    document.body.classList.add('adminbody_bg');

    //set edit user data if exists
    const editUserData = secureLocalStorage.getItem('editUserData');
    if (editUserData) {
      setFormValues({
        id: editUserData.id,
        name: editUserData.name,
        last_name: editUserData.last_name,
        empid: editUserData.empid,
        email: editUserData.email,
        type: editUserData.type,
        location: []
      });
      setIsEdit(true);
      setEditUserData(editUserData);
      secureLocalStorage.removeItem('editUserData');
    }

    // getLocationList({ all: 1 }).then((res) => {
    //   setLocations(res.data.data.locations);
    // }).catch((error) => {
    //   console.log(error);
    // });

  }, []);

  useEffect(() => {
    if (editUserData) {
      let locationArr = locations.filter((item) => editUserData.location_id.split(',').includes(item.location_id.toString()));
      setFormValues({
        ...formValues,
        location: locationArr
      });
    }
  }, [locations, editUserData]);

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  }

  const handleReset = () => {
    setFormValues(formFields);
    setFormErrors(updateNullOfObjectValues(formFields));
    if(isEdit){
      setIsEdit(false);
      setEditUserData(null);
      handleTabChange(null, 0)
    }
  }

  const handleSubmit = () => {
    if (submitting) return;
    if (validateForm()) {
      setSubmitting(true);
      let formData = { ...formValues };
      formData.location = formData.location.map((location) => location.location_id);
      formData.location = formData.location.join(',');

      if (isEdit) {
        updateUser(formData).then((res) => {
          handleSubmitResponse(res);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        addUser(formData).then((res) => {
          handleSubmitResponse(res);
        }).catch((error) => {
          console.log(error);
        });
      }

    }
  }

  const handleSubmitResponse = (res) => {
    setSubmitting(false);
    if (res.data.status) {
      setSubmitSuccess(res.data.message);
      setFormValues(formFields);
      setFormErrors(updateNullOfObjectValues(formFields));
      setTimeout(() => {
        setSubmitSuccess(null);
        handleTabChange(null, 1, true)
      }, 1000);
    } else {
      setSubmitError(res.data.message);
    }
  }

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    if (!formValues.name) {
      formIsValid = false;
      errors['name'] = 'Name is required';
    }

    if (!formValues.last_name) {
      formIsValid = false;
      errors['last_name'] = 'Last name is required';
    }

    if (!formValues.empid) {
      formIsValid = false;
      errors['empid'] = 'Employee id is required';
    }

    if (!formValues.email) {
      formIsValid = false;
      errors['email'] = 'Email is required';
    }

    if (!formValues.type) {
      formIsValid = false;
      errors['type'] = 'User type is required';
    }

    if (!formValues.location.length) {
      formIsValid = false;
      errors['location'] = 'Location is required';
    }

    setFormErrors(errors);
    return formIsValid;
  }

  return (
    <div className='row'>
      <div className='col-md-12 no-padding'>
        <div className='club-sec application-sec'>
          <div className='container-fluid '>

            <div className='form-table-sec table-section-route table-form appl-sec admin-top-sec ad-usr-edit' style={{ marginTop: '5px' }}>
              <div className='row'>
                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Employee Id" variant="standard" className='requireds'
                        onChange={handleChange}
                        name="empid"
                        value={formValues.empid}
                        error={formErrors.empid ? true : false}
                        helperText={formErrors.empid}
                      />
                    </Box>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="First Name" variant="standard" className='requireds'
                        onChange={handleChange}
                        name="name"
                        value={formValues.name}
                        error={formErrors.name ? true : false}
                        helperText={formErrors.name}
                      />

                    </Box>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Last Name" variant="standard" className='requireds'
                        onChange={handleChange}
                        name="last_name"
                        value={formValues.last_name}
                        error={formErrors.last_name ? true : false}
                        helperText={formErrors.last_name}
                      />

                    </Box>
                  </div>
                </div>


                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Email id" variant="standard" className='requireds'
                        onChange={handleChange}
                        name="email"
                        value={formValues.email}
                        error={formErrors.email ? true : false}
                        helperText={formErrors.email}
                      />

                    </Box>
                  </div>
                </div>





              </div>

              <div className='row'>


                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field admn-sel'>
                    <FormControl variant="standard" sx={{ m: 1, width: '90%', margin: '0 auto' }} >
                      <InputLabel id="demo-simple-select-standard-label">User Type<span className='mand-type'>*</span></InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={formValues.type}
                        onChange={handleChange}
                        label="User Type"
                        name='type'
                      >
                        <MenuItem value={'N'}>Nurse</MenuItem>
                        <MenuItem value={'C'}>Coach</MenuItem>
                      </Select>
                      {
                        formErrors.type && <FormHelperText className='manual_error'>{formErrors.type}</FormHelperText>
                      }
                    </FormControl>
                  </div>
                </div>


                <div className='col-md-3'>
                  <div className="auto-loca login-secs">
                    <Stack spacing={3} sx={{ width: '90%', margin: '0 auto' }}>
                      <Autocomplete
                        multiple
                        id="tags-standard"
                        value={formValues.location}
                        options={locations}
                        getOptionLabel={(option) => option.locationName}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onChange={(event, newValue) => {
                          setFormValues({
                            ...formValues,
                            location: newValue
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Select Location"
                            placeholder="Location" className='requireds'
                          />
                        )}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.id}>
                              {option.locationName}
                            </li>
                          );
                        }}
                        renderTags={(tagValue, getTagProps) => {
                          return tagValue.map((option, index) => (
                            <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                          ))
                        }}
                      />
                      {
                        formErrors.location && <FormHelperText className='manual_error'>{formErrors.location}</FormHelperText>
                      }

                    </Stack>
                  </div>
                </div>







              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <div class="login-submit login-submitss btn-adm">
                    <button class="btn btn-login btn-submit bt-forms" type='button' onClick={handleSubmit}>Submit {submitting && <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "white" }} />}</button>
                    {
                      !submitting &&
                      <button class="btn btn-login btn-submit bt-forms btn-reset" type='button' onClick={handleReset}>Reset</button>
                    }
                  </div>
                </div>
              </div>
              

              {
                submitSuccess ?
                  <div className="custome-vali custom-success-msg">
                    <p> {submitSuccess}</p>
                   
                  </div>
                  : null
              }
              {
                submitError ?
                  <div className="custome-vali custom-error-msg" >
                    <p>{submitError}</p>
                  </div>
                  : null
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddEditUser;

